<template src="./template.html"></template>

<script>
  import { Cropper, CircleStencil } from 'vue-advanced-cropper'
  import { mapState } from 'vuex'
  import EXIF from 'exif-js/exif'

  export default {
    name: 'ImageCropper',
    components: {
      CircleStencil,
      Cropper,
    },
    props: {
      pending: Boolean,
      img: {
        type: String,
      },
      circleStencil: Boolean,
    },
    data() {
      return {
        zoom: false,
      }
    },
    computed: {
      ...mapState('auth', ['settings']),
    },
    watch: {
      zoom(value) {
        window.dispatchEvent(new Event('resize'))
        this.onZoom(value)
      },
    },
    created() {
      // enable global exif
      window.EXIF = EXIF
    },
    beforeDestroy() {
      // destroy exif
      window.EXIF = undefined
    },
    methods: {
      onSave($event) {
        const { coordinates } = this.$refs.avatarCropper.getResult()
        this.$emit('onSave', coordinates)

        if ($event) {
          $event.preventDefault()
        }
      },
      onZoom(value) {
        this.$emit('onZoom', value)
      },
    },
  }
</script>
